const SERVICE_URL = 'http://pampett.eu-central-1.elasticbeanstalk.com/api/v1';

const USE_AUTHORIZATION = false;

const OAUTH_BASIC_AUTHORIZATION = 'YmNuYXZpZ2F0b3JjbGllbnQ6YmNuYXZpZ2F0b3JzZWNyZXQ=';

const WET_LOGS_LIMITATION_NO = 30;
const MIN_WET_LOGS_TO_DISPLAY = 20;

const FETCHING_DEVICES_INTERVAL_TIME = 5000; // 5s

export { SERVICE_URL, OAUTH_BASIC_AUTHORIZATION, USE_AUTHORIZATION, WET_LOGS_LIMITATION_NO, MIN_WET_LOGS_TO_DISPLAY, FETCHING_DEVICES_INTERVAL_TIME };


// WEBPACK FOOTER //
// ./src/api/constants.js